import { serverTimestamp } from 'firebase/firestore';
import _ from 'lodash';
import { dataFix } from '../../common/dataFix';
import { createRefPath } from "../../firestoreData/appData/appRefPaths";
import { _settingsFs } from '../../viewSettings/actions/getSettings';
import { checkBasePermissions } from '../contexts/contextHelpers/baseSettings';
import { dispatchProps, grts } from './reducerHelpers/dispatchProps';

export const _appSettingsCollectionName = '_appSettings'
export const _appFormsCollectionName = '_appForms'

const rts = {
  // handleGetAppSettingsFromFunctions: 'handleGetAppSettingsFromFunctions',
  handleBaseSettings_set: 'handleBaseSettings_set',
  handleSetFunctionsAppSettings: 'handleSetFunctionsAppSettings',
  // handleUpdateAdjustedPermissions: 'handleUpdateAdjustedPermissions',
  // handleUpdateAppSettings: 'handleUpdateAppSettings',
  handleGetFormProps: 'handleGetFormProps',
  handleSet_baseSettingsAppArea: 'handleSet_baseSettingsAppArea',
  handleSet_baseSettingsApp: 'handleSet_baseSettingsApp',
  handleSet_appArea: 'handleSet_appArea',
  ...grts
}

const _allowAll = false
const _ammendedTypes = ['_position', 'dividedText', 'hideFromMenu', 'triggerUrl', 'allowSettingsUpdate', 'settingsUpdateHandler', 'settingsUpdateHandlerFunction', 'settingsUpdateAutomatic', 'settingsUpdateDescription']

export const baseSettingsReducer = (state, action) => {

  const { fn_cls, database_fns, accessLevel, baseSettings, baseSettings_combined, pathViews, settingsConsole_home_global, aua } = state
  const { adjustedPermissions: adjustedPermissions_existing } = baseSettings ?? {}
  const { dispatch, type, appArea } = action

  const { handleSetFunctionsAppSettings, handleBaseSettings_set } = baseSettingsHandlers(dispatch)

  switch (type) {

    case rts.handleSet_baseSettingsApp:
      return { ...state, baseSettingsApp: action.baseSettingsApp }

    case rts.handleSet_baseSettingsAppArea:
      return { ...state, appArea: action.appArea, ...action.baseSettingsArea }

    case rts.handleSetFunctionsAppSettings:
      const { app: baseSettings_functions } = action.settings
      console.log('handleSetFunctionsAppSettings', action.settings)
      const adjustedPermissions_functions = checkBasePermissions(baseSettings_functions, settingsConsole_home_global, adjustedPermissions_existing)

      return { ...state, baseSettings_functions: { ...baseSettings_functions, adjustedPermissions: adjustedPermissions_functions } }

    // on init
    // occurs once then on appUserChange
    case rts.handleBaseSettings_set:
      const { hcceSettings: _hcceSettings } = action
      const { app: _baseSettings } = _hcceSettings

      const c = _.cloneDeep(_baseSettings)
      const cs = getCombinedSettings(c)

      return {
        ...state,
        baseSettings: c,
        baseSettings_combined: cs,
      }

    // case rts.handleUpdateAppSettings:
    //   saveBaseSettingsToAppSettings(database_fns, action.dataToUpdate, aua, action.callback)
    //   return { ...state }

    // case rts.handleUpdateAdjustedPermissions:
    //   updateAdjustedPermission(database_fns, action.consoleKey, action.consoleGroup, action.callback)
    //   return { ...state }


    default:
      return { ...state }
  }
}

export const baseSettingsInitialState = (initState) => {
  return { ...initState }
};

export const baseSettingsHandlers = (dispatch) => {
  return {
    handleSet_baseSettingsApp: (baseSettingsApp) => { dispatch({ type: rts.handleSet_baseSettingsApp, dispatch, baseSettingsApp }) },
    handleBaseSettings_set: (hcceSettings) => { dispatch({ type: rts.handleBaseSettings_set, dispatch, hcceSettings }) },
    // handleGetAppSettingsFromFunctions: (appUserAccess, logging) => { dispatch({ type: rts.handleGetAppSettingsFromFunctions, dispatch, appUserAccess, logging }) },
    handleSet_appArea: (appArea) => { dispatch({ type: rts.handleSet_appArea, dispatch, appArea }) },
    handleSet_baseSettingsAppArea: (appArea, baseSettingsArea) => { dispatch({ type: rts.handleSet_baseSettingsAppArea, dispatch, appArea, baseSettingsArea }) },
    handleSetFunctionsAppSettings: (settings) => { dispatch({ type: rts.handleSetFunctionsAppSettings, dispatch, settings }) },
    // handleUpdateAdjustedPermissions: (consoleKey, consoleGroup, callback) => { dispatch({ type: rts.handleUpdateAdjustedPermissions, dispatch, consoleKey, consoleGroup, callback }) },
    // handleUpdateAppSettings: (dataToUpdate, callback) => { dispatch({ type: rts.handleUpdateAppSettings, dispatch, dataToUpdate, callback }) },
  }
}


/**
 * Updates the `consoleKey` field in the `adjustedPermissions` object in _appSettings/app/settings/
 * @param {string} consoleKey 
 * @param {object} consoleGroup 
 * @param {function} callback 
 */
const updateAdjustedPermission = (database_fns, consoleKey, consoleGroup, callback) => {
  const _refVw = createRefPath([_appSettingsCollectionName, 'app', _settingsFs.collection, 'adjustedPermissions'])
  const dataToUpdate = {
    [consoleKey]: consoleGroup
  }
  database_fns.set_doc(_refVw, dataToUpdate, true, callback)
}


const getCombinedSettings = (baseSettings) => {

  const useCombined = true

  const normalItems = ['global', 'other', 'page', 'pageItem', 'prop', 'propSection']

  const { componentPermissions, adjustedPermissions } = baseSettings ?? {}
  const _permissions = adjustedPermissions ? adjustedPermissions : componentPermissions
  const { group } = _permissions ?? {}
  const _combined = {}

  Object.keys(baseSettings).forEach(key => {
    if (normalItems.includes(key)) {
      _combined[key] = {}
      const baseSetting = _.cloneDeep(baseSettings[key])
      const permissionSetting = _permissions[key]
      Object.keys(baseSetting).forEach(bsKey => {
        const baseSettingItem = baseSetting[bsKey]
        const permissionSettingItem = permissionSetting ? permissionSetting[bsKey] : null
        const _cbm = { ...baseSettingItem, ...permissionSettingItem }
        const combined = useCombined ? _cbm : baseSettingItem
        _combined[key][bsKey] = combined
      })
    }
  })

  _combined['group'] = {}

  if (group) {
    Object.keys(group).forEach(groupKey => {
      _combined['group'][groupKey] = group[groupKey]
    })
  }
  return _combined
}


/**
 * Update the _appSettingsCollectionName.app.settings documents
 * @param {object} settings 
 * @param {function} callback 
 */
const saveBaseSettingsToAppSettings = (database_fns, settings, aua, callback) => {
  if (settings) {
    const _settings = dataFix.removeAllEmpties(settings)
    console.log('saveBaseSettingsToAppSettings >>', _settings)
    appSettingsPromise(database_fns, _settings, aua).then(res => {
      console.log('saveBaseSettingsToAppSettings DONE')
      callback({ type: dispatchProps.success })
    }).catch(error => {
      console.log('error!!!!!!!!!!!!!!!!', error)
    })
  }
}

const appSettingsPromise = async (database_fns, settings, aua) => {

  const promises = []

  const _ref = createRefPath([_appSettingsCollectionName, 'app'])

  const _appData = {
    _updateDate: serverTimestamp(),
    ...aua,
  }
  promises.push(database_fns.set_doc(_ref, _appData, true)
  )
  Object.keys(settings).forEach(sk => {
    const setting = settings[sk]
    const _docRef = createRefPath([_appSettingsCollectionName, 'app', _settingsFs.collection, sk])
    promises.push(database_fns.set_doc(_docRef, setting, false))
  })
  return Promise.all(promises)
}

